document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-env-menu]').forEach(function(button){
    button.addEventListener('click',function(){
      var header=button.closest('[data-env-header]');
      if(!header)return;
      var open=header.classList.toggle('is-open');
      button.setAttribute('aria-expanded',open?'true':'false');
    });
  });
  var header=document.querySelector('[data-env-header]');
  if(header){var scroll=function(){header.classList.toggle('is-scrolled',window.scrollY>20);};scroll();window.addEventListener('scroll',scroll,{passive:true});}
  document.querySelectorAll('[data-env-reveal]').forEach(function(el){
    if(!('IntersectionObserver' in window)){el.classList.add('is-visible');return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target);}})},{threshold:.1});
    io.observe(el);
  });
});

